export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType("container");
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    const TYPE_NAME = "APPLICATION-COREGISTRATION";
    const CATEGORY = "ADVANCE COMPONENT";
    const DATA_TYPE_ATTR_NAME = "data-lg-type";
    var model = MODEL.extend(
        {
            defaults: {
                ...MODEL.prototype.defaults,
                "custom-name": `C-${TYPE_NAME}`,
                attributes: {
                    [DATA_TYPE_ATTR_NAME]: `C-${TYPE_NAME}`,
                },
                classes: [],
                traits: MODEL.prototype.defaults.traits.concat([
                    // { type: "slider", name: "value", label: false },
                    {
                        type: "custom_select",
                        placeholder: "-- Select a campaign --",
                        optionsValue: "campaign_uid",
                        optionsLabel: "campaign_name",
                        endpoint: "/campaigns.api/coregisterList",
                        name: "data-lg-campaign-uuid",
                        label: "Campaign",
                    },
                    {
                        type: "text",
                        placeholder: "Redirect URL",
                        name: "data-lg-redirect-url",
                        label: "Redirect URL",
                    },
                    {
                        type: "number",
                        placeholder: "Time redirect",
                        name: "data-lg-time-redirect",
                        label: "Time redirect",
                    },
                    {
                        type: "select",
                        placeholder: "Redirect target",
                        name: "data-lg-redirect-target",
                        options: [
                            {value: '_self', name: 'This window'},
                            {value: '_blank', name: 'New window'},
                        ],
                        label: "Redirect target",
                    },
                ]),
                components: [
                    {
                        type: "row",
                        classes: ["row"],
                        selectable: false,
                        components: [
                            {
                                type: "column",
                                classes: ["col"],
                                components: [
                                    {
                                        type: "header",
                                        content: "Title",
                                    },
                                    {
                                        type: "paragraph",
                                        content:
                                            "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.",
                                    },
                                ],
                            },
                            {
                                type: "column",
                                classes: ["col", "col-md-2"],
                                style: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "space-around",
                                },
                                components: [
                                    {
                                        type: "C-APPLICATION-COREGISTRATION-REQUEST-BUTTON",
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            onRender() {},
        },
        {
            isComponent(el) {
                if (
                    el &&
                    el.getAttribute &&
                    el.getAttribute(DATA_TYPE_ATTR_NAME) == `C-${TYPE_NAME}`
                )
                    return { type: `C-${TYPE_NAME}` };
            },
        }
    );
    var view = VIEW.extend({});

    DOMC.addType(`C-${TYPE_NAME}`, {
        model: model,
        view: view,
    });

    BM.add(`B-${TYPE_NAME}`, {
        label: `${TYPE_NAME}`,
        content: {
            type: `C-${TYPE_NAME}`,
        },
        category: CATEGORY,
    });
};
